import React, { useState, useEffect } from "react";
import { Container, Grid } from "@material-ui/core";
import CourseCard from "./CourseCard.js";
import NewCourse from "./NewCourse.js";
import API from "../../actions";

export default props => {
    const [courses, setCourses] = useState([]);

    useEffect(() => {
        getCourses();
    }, []);

    const getCourses = async () => {
        const courses = await API.getEventsFromTherapist();
        const dates = await API.getEventDatesFromTherapist();
        const courseMap = {};
        courses.forEach(course => {
            courseMap[course.id] = course;
            courseMap[course.id].dates = [];
        });
        dates.forEach(date => courseMap[date.eventId].dates.push(date));
        setCourses(courses.map(course => courseMap[course.id]));
    };

    props.setLocationName();

    return (
        <Container maxWidth="lg">
            <NewCourse new={true} getCourses={getCourses} />
            <Grid container spacing={3}>
                {courses.map((course, index) => {
                    return (
                        <Grid item xs={12} sm={6} key={course.id + index}>
                            <CourseCard course={course} getCourses={getCourses} />
                        </Grid>
                    );
                })}
            </Grid>
        </Container>
    );
};
